import { render, staticRenderFns } from "./squareHade.vue?vue&type=template&id=71aef778&scoped=true&"
import script from "./squareHade.vue?vue&type=script&lang=js&"
export * from "./squareHade.vue?vue&type=script&lang=js&"
import style0 from "./squareHade.vue?vue&type=style&index=0&id=71aef778&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71aef778",
  null
  
)

export default component.exports